import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";
import { Toast } from "react-bootstrap";

const toastVariantByType = {
  success: "success",
  error: "danger",
  info: "primary",
  warning: "warning",
};

export type ToastVariants = keyof typeof toastVariantByType;

const showToast = (message: string, variant: ToastVariants) => {};

export const ToastContext = createContext({ showToast });

export type ToastType = {
  id: number;
  message: string;
  type: ToastVariants;
};

const ToastProvider: FC<PropsWithChildren> = ({ children }) => {
  const [toastList, setToastList] = useState<ToastType[]>([]);
  const showToast = useCallback(
    (message: string, type: ToastVariants) =>
      setToastList([...toastList, { id: Date.now(), message, type }]),
    [toastList]
  );
  return (
    <ToastContext.Provider value={{ showToast }}>
      <div className="toast-wrapper">
        {toastList.map((toast) => (
          <Toast
            className="m-1"
            key={toast.id}
            // position={'top-end'}
            autohide
            bg={toastVariantByType[toast.type]}
            show={!!toast.message}
            onClose={() => {
              setToastList(toastList.filter((item) => item.id !== toast.id));
            }}
          >
            <div className={"p-2"}>
              <span></span>
              <span>{toast.message}</span>
            </div>
          </Toast>
        ))}
      </div>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);

export default ToastProvider;
